import * as React from "react";

export function About() {
  return (
    <div>
      <h2>About</h2>
    </div>
  );
}
